var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters['Loader/dialogLoading'])?_c('v-overlay',{attrs:{"z-index":"10","color":"#000000","opacity":".6"}},[_c('div',{attrs:{"clas":"d-flex flex-column"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64","width":"3","color":"primary"}}),_c('div',{staticClass:"mt-2 primary--text"},[_vm._v("saving ....")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }